import AllHome from './Home/AllHome';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Subheader from "./Subheader";
import Navbar from "./Navbar";

function App() {
  return (
    <div className="App">
      <Subheader />
      <Navbar />
     <AllHome/>
        
    </div>
  );
}

export default App;
